/** The Life readings as outcomes: nobody wants a dasamsa, they want to know when money gets easier. */
export interface LifeOutcome {
  readonly reading: "money" | "year" | "love" | "timing";
  readonly row: string;
  readonly sub: string;
  readonly wallTitle: string;
  readonly wallBody: string;
}

export const LIFE_OUTCOMES: readonly LifeOutcome[] = [
  {
    reading: "money",
    row: "When money gets easier",
    sub: "Your earning years, dated",
    wallTitle: "Your money gets easier in 2027. Here’s why, and what to do until then.",
    wallBody: "The earning years in your chart, dated — which ones build and which ones drain, and what each one rewards.",
  },
  {
    reading: "year",
    row: "What this year is asking of you",
    sub: "Through to March 2027",
    wallTitle: "What this year is actually asking of you.",
    wallBody: "Not a horoscope. The period you are in, what it tends to demand, and the months that matter inside it.",
  },
  {
    reading: "love",
    row: "How you love, and what breaks it",
    sub: "The pattern, not the platitude",
    wallTitle: "How you love, and the thing that keeps breaking it.",
    wallBody: "The pattern your chart repeats in relationships — and the specific years it eases.",
  },
  {
    reading: "timing",
    row: "When to make the move",
    sub: "Job, city, or the conversation",
    wallTitle: "When to make the move.",
    wallBody: "Job, city, or the conversation you keep postponing. The windows that favour it, with dates.",
  },
];

export function outcomeFor(reading: string): LifeOutcome | undefined {
  return LIFE_OUTCOMES.find((o) => o.reading === reading);
}

export interface WallCopy {
  readonly eyebrow: string;
  readonly title: string;
  readonly body: string;
}

/** A subscriber who has used the month's hour of voice: typing stays open. */
export const WALL_VOICE_MONTH_USED: WallCopy = {
  eyebrow: "This month",
  title: "You’ve used this month’s hour of voice.",
  body: "It starts again on the 1st. Until then you can type to her as much as you like.",
};

export function wallForOutcome(outcome: LifeOutcome): WallCopy {
  return { eyebrow: "On Antar", title: outcome.wallTitle, body: outcome.wallBody };
}

export function wallForCompatibility(friend: string, freeFriend: string): WallCopy {
  return {
    eyebrow: "One friend free",
    title: `${freeFriend}’s already yours. ${friend} isn’t.`,
    body: "Compatibility with everyone else — and the daily line between you and each of them — is on Antar.",
  };
}
